//clase de materia
export class Materia {
    constructor({
      nombremateria = "",
      ultimaModificacion = 0,
      materiaActiva = true,
      categoria = "",
      descripcionMateria = "",
      precioAsesoria = 0,
      comentarioPrecioAsesoria = "",
    } = {}){
      this.nombremateria = nombremateria;
      this.ultimaModificacion = ultimaModificacion;
      this.materiaActiva = materiaActiva;
      this.categoria = categoria;
      this.descripcionMateria = descripcionMateria;
      this.precioAsesoria = precioAsesoria;
      this.comentarioPrecioAsesoria = comentarioPrecioAsesoria;
    }
  
    static fromJson(json){
      const activoLocal = json['activo'] ?? true;
  
      return new Materia({
        nombremateria: json['nombremateria'] ?? '',
        ultimaModificacion: json['ultimaModificacion'] ?? 0,
        materiaActiva: json['materiaActiva'] ?? true,
        categoria: json['categoria'] ?? '',
        descripcionMateria: json['descripcionMateria'] ?? '',
        precioAsesoria: json['precioAsesoria'] ?? 0,
        comentarioPrecioAsesoria: json['comentarioPrecioAsesoria'] ?? '',
      });
  
    }

    toJson(){
        return{
            'nombremateria': this.nombremateria,
            'ultimaModificacion' : this.ultimaModificacion,
            'materiaActiva' : this.materiaActiva,
            'categoria' : this.categoria,
            'descripcionMateria' : this.descripcionMateria,
            'precioAsesoria' : this.precioAsesoria,
            'comentarioPrecioAsesoria' : this.comentarioPrecioAsesoria,
        }
    }

    toMap(){
        return{
            'nombremateria': this.nombremateria,
            'ultimaModificacion' : this.ultimaModificacion,
            'materiaActiva' : this.materiaActiva,
            'categoria' : this.categoria,
            'descripcionMateria' : this.descripcionMateria,
            'precioAsesoria' : this.precioAsesoria,
            'comentarioPrecioAsesoria' : this.comentarioPrecioAsesoria,
          };
        }
}
export const formMateriaInicial = {
  nombremateria : "",
  ultimaModificacion : 0,
  materiaActiva : true,
  categoria : "",
  descripcionMateria :"",
  precioAsesoria : 0,
  comentarioPrecioAsesoria : "",
};
  
//universidades
export class Universidad{
  constructor({
    docId = "",
    nombreUniversidad = "",
    ultimaModificacion = 0,
  } = {}){
    this.docId = docId;
    this.nombreUniversidad = nombreUniversidad;
    this.ultimaModificacion = ultimaModificacion;
  }

  static fromJson(json){

    return new Universidad({
      docId: json['docId'] ?? '',
      nombreUniversidad: json['nombre Universidad'] ?? '',
      ultimaModificacion:  json['ultimaModificacion'] ?? 0,
    });

  };

  toJson(){

  };

}

//carreras
export class Carrera{
  constructor({
    docId = "",
    nombrecarrera = "",
    ultimaModificacion = 0,
  } = {}){
    this.docId = docId;
    this.nombrecarrera = nombrecarrera;
    this.ultimaModificacion = ultimaModificacion;
  }

  static fromJson(json){

    return new Carrera({
      docId: json['docId'] ?? '',
      nombrecarrera: json['nombre carrera'] ?? '',
      ultimaModificacion:  json['ultimaModificacion'] ?? 0,
    });

  };

  toMap(){

  }

}

